import React from "react";
import useEventStore from "./store/eventStore";

const EventDetailTabs = () => {
  const options = [
    {
      id: 1,
      name: "Overview",
    },
    {
      id: 2,
      name: "Participation",
    },
    {
      id: 3,
      name: "Schedule",
    },
    {
      id: 4,
      name: "Leaderboard",
    },
  ];

  const selectedOption = useEventStore((state) => state.currentContentTab);
  const setSelectedOption = useEventStore(
    (state) => state.setCurrentContentTab
  );

  return (
    <div className="text-[13px] flex items-center px-5 gap-[10px] flex-nowrap overflow-x-auto hide-scrollbar my-3">
      {options.map((item) => (
        <button
          key={item.id}
          className={`px-2 py-1 rounded-lg ${
            selectedOption?.id === item.id ? "bg-[#F80B7B]" : "bg-[#333333]"
          }`}
          onClick={() => setSelectedOption(item)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

export default EventDetailTabs;
